( function( $ ) {

    $(document).ready( function() {

        if ($('.wp-block-st-loop').length > 0) {

        var allLocations = [];
        var markers = [];
        var markerCluster;
        var locations = mapData.locations;
        var map;
        var mapCenter = {lat: parseFloat(document.getElementById('map').dataset.lat), lng: parseFloat(document.getElementById('map').dataset.lng)};
        var zoom = parseInt(document.getElementById('map').dataset.zoom);

        let perPage = parseInt( $('.wp-block-st-loop').data('per-page') );

        let bounds = new google.maps.LatLngBounds();

        var svgIcon = window.location.origin + '/wp-content/themes/studiothink/assets/images/map-marker.svg';


        // Map styling
        var mapStyles = [
            {
            "elementType": "geometry",
            "stylers": [
                {
                "color": "#ffffff"
                }
            ]
            },
            {
            "elementType": "labels.icon",
            "stylers": [
                {
                "visibility": "off"
                }
            ]
            },
            {
            "elementType": "labels.text.fill",
            "stylers": [
                {
                "color": "#616161"
                }
            ]
            },
            {
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                "color": "#f5f5f5"
                }
            ]
            },
            {
            "featureType": "administrative.land_parcel",
            "stylers": [
                {
                "visibility": "off"
                }
            ]
            },
            {
            "featureType": "administrative.land_parcel",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                "color": "#bdbdbd"
                }
            ]
            },
            {
            "featureType": "administrative.neighborhood",
            "stylers": [
                {
                "visibility": "off"
                }
            ]
            },
            {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
                {
                "color": "#eeeeee"
                }
            ]
            },
            {
            "featureType": "poi",
            "elementType": "labels.text",
            "stylers": [
                {
                "visibility": "off"
                }
            ]
            },
            {
            "featureType": "poi",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                "color": "#757575"
                }
            ]
            },
            {
            "featureType": "poi.business",
            "stylers": [
                {
                "visibility": "off"
                }
            ]
            },
            {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [
                {
                "color": "#e5e5e5"
                }
            ]
            },
            {
            "featureType": "poi.park",
            "elementType": "labels.text",
            "stylers": [
                {
                "visibility": "off"
                }
            ]
            },
            {
            "featureType": "poi.park",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                "color": "#9e9e9e"
                }
            ]
            },
            {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [
                {
                "color": "#ffffff"
                }
            ]
            },
            {
            "featureType": "road",
            "elementType": "labels",
            "stylers": [
                {
                "visibility": "off"
                }
            ]
            },
            {
            "featureType": "road.arterial",
            "stylers": [
                {
                "visibility": "off"
                }
            ]
            },
            {
            "featureType": "road.arterial",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                "color": "#757575"
                }
            ]
            },
            {
            "featureType": "road.highway",
            "elementType": "geometry",
            "stylers": [
                {
                "color": "#dadada"
                }
            ]
            },
            {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [
                {
                "color": "#48283c"
                }
            ]
            },
            {
            "featureType": "road.highway",
            "elementType": "labels",
            "stylers": [
                {
                "visibility": "off"
                }
            ]
            },
            {
            "featureType": "road.highway",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                "color": "#616161"
                }
            ]
            },
            {
            "featureType": "road.local",
            "stylers": [
                {
                "visibility": "off"
                }
            ]
            },
            {
            "featureType": "road.local",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                "color": "#9e9e9e"
                }
            ]
            },
            {
            "featureType": "transit.line",
            "elementType": "geometry",
            "stylers": [
                {
                "color": "#e5e5e5"
                }
            ]
            },
            {
            "featureType": "transit.station",
            "elementType": "geometry",
            "stylers": [
                {
                "color": "#eeeeee"
                }
            ]
            },
            {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
                {
                "color": "#c9c9c9"
                }
            ]
            },
            {
            "featureType": "water",
            "elementType": "labels.text",
            "stylers": [
                {
                "visibility": "off"
                }
            ]
            },
            {
            "featureType": "water",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                "color": "#9e9e9e"
                }
            ]
            }
        ];

        // Function to initialize the map
        function initMap() {
            // Center the map on a default location
            

            // Create the map
            map = new google.maps.Map(document.getElementById('map'), {
                zoom: 4,
                center: mapCenter,
                styles: mapStyles,
                gestureHandling: "cooperative",
                zoomControl: true, 
                mapTypeControl: false,
                streetViewControl: false, 
                fullscreenControl: false ,
            });

            // Autocomplete: Initialize the search box (places input)
            var input = document.getElementById('search-box');
            var autocomplete = new google.maps.places.Autocomplete(input);
            autocomplete.bindTo('bounds', map);

            // Update the map based on the selected location from autocomplete
            autocomplete.addListener('place_changed', function() {
                var place = autocomplete.getPlace();
                if (!place.geometry) {
                    console.log("Autocomplete's returned place contains no geometry");
                    return;
                }

                // If the place has geometry, center the map on the place
                if (place.geometry.viewport) {
                    map.fitBounds(place.geometry.viewport);
                    map.setZoom(9);
                }
            });

            updateMarkers(locations);

            // Debounce logic
            let debounceTimer;
            function debounce(callback, delay) {
                clearTimeout(debounceTimer);
                debounceTimer = setTimeout(callback, delay);
            }

             // Add listener to update the list when the map bounds change
            google.maps.event.addListener(map, 'bounds_changed', function() {
                debounce(function() {
                    updatePostsAndMarkersByBounds(map);
                }, 500);  // Delay for 500ms (adjust as needed)
            });
            
        }

        initMap();

        function updateMarkers(locations) {
            // Add standard markers for each location
            markers.forEach(function(marker) {
                marker.setMap(null);
            });

            bounds = new google.maps.LatLngBounds()

            allLocations = [];
            markers = [];

            // if markerCluster is defined, remove it
            if (markerCluster) {
                markerCluster.clearMarkers();
            }


            locations.forEach(function(location) {
                var marker = new google.maps.Marker({
                    position: {lat: location.lat, lng: location.lng},
                    map: map,
                    title: location.name,
                    icon: {
                        url: svgIcon,
                        scaledSize: new google.maps.Size(50, 50),  // Adjust size
                        anchor: new google.maps.Point(25, 50)  // Anchor point for the marker
                    }
                });
                markers.push(marker);
                allLocations.push({
                    ...location, // Copy the location data
                    marker: marker  // Store marker in the location object for easy reference
                });

                bounds.extend(marker.getPosition());

                google.maps.event.addListener(marker, 'click', function() {
                    
                    $('.loop-item').show();
                    resetAccordionHeight();
                    $('.accordion-item').removeClass('open');
                    $('#accordion-item-' + location.post_id).addClass('open');
                    document.getElementById('accordion-item-' + location.post_id).scrollIntoView({
                        behavior: 'smooth'
                    });
                    $('.load-more').hide();
                });
            });

            if (locations.length > 0) {
                map.fitBounds(bounds);

                if (map.getZoom() > 15) {  // Set the maximum zoom level you want to allow
                    map.setZoom(15);  // Zoom back out to a reasonable level
                }

            } else {
                // Set the map to a default zoom and center if no locations are found
                map.setZoom(4);
                // map.setCenter({lat: 51.6425119, lng: 15.9287583});
            }

            // Add marker clusterer to manage the markers
            markerCluster = new markerClusterer.MarkerClusterer({
                map,
                markers: markers,
                imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'  // Path to cluster icons
            });

            
        }

        function updatePostsAndMarkersByBounds(map) {
            let bounds = map.getBounds();
            let visibleLocations = [];

            // Clear all existing markers from the cluster
            markerCluster.clearMarkers();

            // Loop through all markers and check if they are within the bounds
            markers.forEach(function(marker, index) {
                let location = allLocations[index];  // Get the associated location data
                let latLng = new google.maps.LatLng(location.lat, location.lng);
                if (bounds.contains(latLng)) {
                    visibleLocations.push(location);  // Add location to visible list if within bounds
                    marker.setMap(map);  // Show marker if it's within bounds
                } else {
                    marker.setMap(null);  // Hide marker if it's outside the bounds
                }
            });

            markerCluster.addMarkers(markers.filter(marker => marker.getMap() !== null));
        
            // Update the post list with visible locations
            updatePostList(visibleLocations);
        }


        // END MAP



            const postType = 'location';

            //  Init Select 2
            $('.select2-filter').select2({
                minimumResultsForSearch: -1,
                dropdownAutoWidth: true,
                multiple: false,
                theme: "flat",
            }).promise(function() {
                
            });

            

            function initCityFilter() {
                $('.select2-filter[data-taxonomy="city"]').select2({
                    minimumResultsForSearch: Infinity,
                    dropdownAutoWidth: true,
                    theme: "flat",
                    placeholder: $(this).data("placeholder"),
                    ajax: {
                    type: 'POST',
                    url: "/wp-admin/admin-ajax.php",
                    dataType: 'json',
                    data: function() {
                        let s2DataArgs = {
                        action: 'subcat_filter',
                        country: $('.select2-filter[data-taxonomy="country"]').val(),
                        all: $(this).data("all")
                        }
                        
            
            
                        return s2DataArgs;
                    },
                    }
                });
            }
            initCityFilter();
            

            $('.filter-select select, #expert').on('change', function () {
                // Get the selected filters
                let selectedCountry = $('#country').val();
                let selectedCity = $('#city').val();
                let inStoreExpertChecked = $('#expert').prop('checked') ? true : false;
            
                // Send an AJAX request to get the filtered locations
                $.ajax({
                    type: 'POST',
                    url: '/wp-admin/admin-ajax.php',
                    dataType: 'json',
                    data: {
                        action: 'filter_locations',  // Custom action for filtering locations in WordPress
                        country: selectedCountry,
                        city: selectedCity,
                        expert: inStoreExpertChecked
                    },
                    success: function (response) {
                        if (response.success && response.data.locations) {
                            // Update the mapData locations with the filtered locations
                            locations = response.data.locations;
            
                            // Update the map with the new filtered locations
                            updateMarkers(locations);
                        } else {
                            console.error('No locations returned from the server');
                        }
                    },
                    error: function (xhr, status, error) {
                        console.error("Error fetching filtered locations:", error);
                    }
                });
            });

            
            function updatePostList(filteredLocations) {

                let visiblePostIds = filteredLocations.map(loc => loc.post_id);  // Get the post IDs of visible locations

                $.ajax({
                    type: 'POST',
                    url: '/wp-admin/admin-ajax.php',
                    dataType: 'html',
                    data: {
                        action: 'filter_loop',  // Action to filter the post list
                        post_ids: visiblePostIds,
                        post_type: 'location'
                    },
                    success: function (response) {
                        $('.loop-inner-grid').html(response);

                        let i = 0;
                        $('.loop-inner-grid').find('.loop-item').each(function() {
                            if (i > perPage) {
                                $(this).hide();
                            }
                            i++;
                        });
                        if (i <= perPage) {
                            $('.load-more').hide();
                        } else {
                            $('.load-more').show();
                        }
                        
                        resetAccordionHeight();
                    }
                });
            }


            $(document).on('click', '.load-more a', function(e) {
                e.preventDefault();

                $('.loop-item').show();
                $(this).parent().parent().hide();
                resetAccordionHeight();

            });

            function resetAccordionHeight() {
                setTimeout(function() {
                    $('.accordion-body-wrapper').each(function() {
                    
                        
                        let height = $(this).children('.accordion-body-inner').outerHeight(true) + 1 + 'px';
                        $(this).css('--body-height', height);

                    
                    });
            }, 100);
            }
            
            resetAccordionHeight();

            $(window).on('resize', function() {
                resetAccordionHeight();
            });
    
    
            $(document).on('click', '.accordion-title', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                if($(this).parent().hasClass('open')) {
                    $(this).parent().removeClass('open');
                } else {
                    $('.accordion-item').removeClass('open');
                    $(this).parent().addClass('open');
                }

                // if ($(this).parent().hasClass('open')) {
                //     // gtag(
                //     //     'event', 'openedLocation',
                //     //     {
                //     //         'location': $(this).find('.accordion-heading').text()
    
                //     //     }
                //     // );
    
                // }
            });

            $('.select2-filter').each(function() {
                if($(this).next('.select2').find('.select2-selection__rendered').find('.select2-selection__placeholder').length === 0) {
                    $(this).next('.select2').find('.select2-selection__rendered').attr('data-taxonomy', $(this).data('placeholder') + ': ');
                }

                
            });

            map.setCenter(mapCenter);
            map.setZoom(12);

            window.setTimeout(function() {
                map.setCenter(mapCenter);
                map.setZoom(zoom);

            }, 300);
        }

        $('.filter-wrapper ').css('display', 'flex');
        $('.loop-inner-grid').css('display', 'block');
        $('.loop-pagination').css('display', 'block');

    } );

} )( jQuery );
